import ReactJson from '@microlink/react-json-view'
import React from 'react'

// Convert these timestamps to dates
const TIMESTAMP_FIELDS = {
  modifiedAt: true,
  inviteSentAt: true,
  createdAt: true,
  processedAt: true,
  activateTransactionsAt: true,
}

export interface JSONDetailPanelProps {
  src: Record<string, any>
  collapsed?: boolean
}

export default function JSONDetailPanel({ src: obj, collapsed = false }: JSONDetailPanelProps) {
  const _obj = Object.keys(obj)
    .filter((key) => key !== 'tableData')
    .reduce((a, key) => {
      if (TIMESTAMP_FIELDS[key] && obj[key]) {
        a[key] = new Date(obj[key] * 1000)
      } else {
        a[key] = obj[key]
      }
      return a
    }, {})
  return <ReactJson src={_obj} collapsed={collapsed} />
}
